import { render, staticRenderFns } from "./AccountDocumentation.vue?vue&type=template&id=764c94e0&scoped=true"
import script from "./AccountDocumentation.vue?vue&type=script&lang=js"
export * from "./AccountDocumentation.vue?vue&type=script&lang=js"
import style0 from "@/assets/docs/styles/documentation.css?vue&type=style&index=0&id=764c94e0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c94e0",
  null
  
)

export default component.exports